import { z } from 'zod'

import { apiOpsV2 } from '@/lib/api/ops-v2'

const RoleMemberSchema = z.looseObject({
  userId: z.string()
})

export const RoleDetailSchema = z.looseObject({
  id: z.string(),
  members: z.array(RoleMemberSchema).nullish()
})

export type RoleDetailDto = z.infer<typeof RoleDetailSchema>

export async function fetchRoleById(roleId: string): Promise<RoleDetailDto> {
  const res = await apiOpsV2.get(`/permissions/user-role/${roleId}`)
  return RoleDetailSchema.parse(res.data)
}
